module.exports = __webpack_public_path__ + "img/Semana00086430.58a3560b.jpg";